// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ef64532525efaa07b6f852536195a35d8cf0943f.chunk.bundle.js";
};